<script>
import LoadOnDemand from 'comp/modules/LoadOnDemand.vue'
import DialogModules from 'comp/modules/DialogModules'

import { mapGetters } from 'vuex'
import { getPartyConduct } from '@/api/pageData'
import { themeConfigureImgUrl } from '@/utils/common'

export default {
  components: { LoadOnDemand, DialogModules },
  data() {
    return {
      currentCommunity: localStorage.getItem('currentCommunity'),
      pageData: [],
      currentModule: {},
      currentModuleItemDataId: 0,
      currentModuleItemDataHeadline: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentNavObj: 'config/getCurrentNavObj',
      currentModalNameGetter: 'config/getCurrentModalName',
      screenSizeGetter: 'config/getScreenSize'
    }),
    currentNavObj() { return this.getCurrentNavObj },
    currentModalName() { return this.currentModalNameGetter },
    screenSize: {
      get() {
        return this.screenSizeGetter
      }
    },
    has32Module() {
      let bool = false
      this.pageData.forEach(item => {
        if (item.list[0].id === 32) bool = true
      })
      return bool
    }
  },
  watch: {
    screenSize(newVal, oldVal) {
      this.$nextTick(() => {
        const enlarge_dom = document.getElementById('pulic-main-content')
        enlarge_dom.style.transform = `scale(${newVal})`
        enlarge_dom.style.transformOrigin = '0 0'
      })
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    themeConfigureImgUrl,
    onCheckDetail(v) {
      this.currentModule = v
      // if (v.id === 32) return
      this.$store.commit('config/SET_CURRENT_MODALNAME', v.title)
      this.$store.commit('config/SET_CURRENT_MODULE_ID', v.id)
      this.$store.commit('config/SET_DIALOG', true)
    },
    onModuleItem(v) {
      this.currentModuleItemDataId = v?.id || 0
      this.currentModuleItemDataHeadline = v?.headline || ''
    },

    initPageData() {
      const params = {
        village: this.currentCommunity,
        title: this.currentNavObj.templateName,
        userid: localStorage.getItem('screenUserid') || 0,
        tid: this.currentNavObj.id
      }
      getPartyConduct(params).then(res => {
        if (res.code === 0) this.pageData = res.msg
      })
    }
  }
}
</script>

<template>
  <div
    class="page-used-style party-conduct"
    :style="{
      background: `url(${themeConfigureImgUrl(currentNavObj.pageBg)}) no-repeat center`,
      backgroundSize: '100% 100%'
    }"
  >
    <div class="enlarge-box">
      <div id="pulic-main-content" :class="has32Module ? 'pulic-main-content' : 'normal-main-content'">
        <load-on-demand
          v-for="(v, i) in pageData"
          :key="`load-demand-${i}`"
          class="load-on-item"
          :page-data-obj="v.list[0]"
          @click.native="onCheckDetail(v.list[0])"
          @onModuleItem="onModuleItem"
        />
      </div>
    </div>

    <Dialog>
      <template #content-main>
        <dialog-modules
          v-if="currentModalName"
          :current-module="currentModule"
          :current-module-item-data-id="currentModuleItemDataId"
          :current-module-item-data-headline="currentModuleItemDataHeadline"
        />
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
.party-conduct {
  .pulic-main-content {
    width: 1500px;
    height: 944px;
    overflow-y: scroll;
    padding: 35px 0;
    box-sizing: border-box;
    transition: all .2s ease-in;

    // display: flex;
    // flex-wrap: wrap;
    // column-gap: 65px;
    // row-gap: 80px;
    $count: 8;
    @function randomNum($max, $min: 0, $u: 1) {
        @return ($min + random($max)) * $u;
    }
    @function randomColor() {
        @return rgb(randomNum(255), randomNum(255), randomNum(255));
    }
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 38px;

    @for $i from 1 to $count+1 {
      // .load-on-item:nth-child(#{$i}) {
      //   position: relative;
      //   background: randomColor();
      //   &::after {
      //       content: "#{$i}";
      //       position: absolute;
      //       color: #fff;
      //       font-size: 2vw;
      //       top: 50%;
      //       left: 50%;
      //       transform: translate(-50%, -50%);
      //   }
      // }
    }
    .load-on-item {
      &:nth-child(1) {
        grid-column: 1;
        grid-row: 1 / 3;
      }
      &:nth-child(2) {
        grid-column: 2;
        // grid-row: 1 / 4;
      }
      &:nth-child(3) {
        grid-column: 3;
        // grid-row: 1 / 5;
      }
    }

    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }

  .normal-main-content {
    width: 1500px;
    height: 944px;
    overflow-y: scroll;
    padding: 35px 0;
    box-sizing: border-box;
    transition: all .2s ease-in;

    display: flex;
    flex-wrap: wrap;
    column-gap: 65px;
    row-gap: 80px;

    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
}
</style>
